import epsClient from 'enrollment-platform/api/eps.client'
import type {
  BulkDeleteOverrideRulesRequestDto,
  BulkUpdateStatusByIdsRequestDto,
  CheckDuplicateOverrideRuleQueryDto,
  CheckDuplicateOverrideRuleResponseDto,
  CreatePlanBenefitOverrideRuleRequestDto,
  DeleteOverrideRulesByFilterRequestDto,
  DeleteOverrideRulesByFilterResponseDto,
  ListPlanBenefitOverrideRulesQueryDto,
  ListPlanBenefitOverrideRulesResponseDto,
  ListPlanBenefitOverruleTemplatesResponseDto,
  ListPlanBenefitsResponseDto,
  PlanBenefitOverrideRuleResponseDto,
  UpdatePlanBenefitOverrideRuleRequestDto,
  UpdatePlanBenefitOverrideRuleStatusRequestDto,
  UpdateStatusByFilterBodyDto,
  UpdateStatusByFilterQueryDto,
  UpdateStatusByFilterResponseDto,
  UpsertFieldRequestDto,
} from './dto/plan-benefit-override-rules.dto'

export const PLAN_BENEFIT_OVERRIDE_RULE_BASE =
  '/api/v1/plan-benefit-override-rules'

const BASE_PATH = PLAN_BENEFIT_OVERRIDE_RULE_BASE

export const listOverrideRules = async (
  params: ListPlanBenefitOverrideRulesQueryDto
): Promise<ListPlanBenefitOverrideRulesResponseDto> => {
  const { data } = await epsClient.get<ListPlanBenefitOverrideRulesResponseDto>(
    BASE_PATH,
    { params }
  )
  return data
}

export const getOverrideRule = async (
  id: string
): Promise<PlanBenefitOverrideRuleResponseDto> => {
  const { data } = await epsClient.get<PlanBenefitOverrideRuleResponseDto>(
    `${BASE_PATH}/${id}`
  )
  return data
}

export const createOverrideRule = async (
  body: CreatePlanBenefitOverrideRuleRequestDto
): Promise<PlanBenefitOverrideRuleResponseDto> => {
  const { data } = await epsClient.post<PlanBenefitOverrideRuleResponseDto>(
    BASE_PATH,
    body
  )
  return data
}

export const updateOverrideRule = async (
  id: string,
  body: UpdatePlanBenefitOverrideRuleRequestDto
): Promise<PlanBenefitOverrideRuleResponseDto> => {
  const { data } = await epsClient.patch<PlanBenefitOverrideRuleResponseDto>(
    `${BASE_PATH}/${id}`,
    body
  )
  return data
}

export const getTemplates =
  async (): Promise<ListPlanBenefitOverruleTemplatesResponseDto> => {
    const { data } =
      await epsClient.get<ListPlanBenefitOverruleTemplatesResponseDto>(
        `${BASE_PATH}/templates`
      )
    return data
  }

export const getPlanBenefits =
  async (): Promise<ListPlanBenefitsResponseDto> => {
    const { data } = await epsClient.get<ListPlanBenefitsResponseDto>(
      `${BASE_PATH}/benefits`
    )
    return data
  }

export const checkDuplicateOverrideRule = async (
  query: CheckDuplicateOverrideRuleQueryDto
): Promise<CheckDuplicateOverrideRuleResponseDto> => {
  const { data } = await epsClient.get<CheckDuplicateOverrideRuleResponseDto>(
    `${BASE_PATH}/check-duplicate`,
    { params: query }
  )
  return data
}

export const updateOverrideRuleStatus = async (
  id: string,
  body: UpdatePlanBenefitOverrideRuleStatusRequestDto
): Promise<PlanBenefitOverrideRuleResponseDto> => {
  const { data } = await epsClient.patch<PlanBenefitOverrideRuleResponseDto>(
    `${BASE_PATH}/${id}/status`,
    body
  )
  return data
}

export const deleteOverrideRule = async (id: string): Promise<void> => {
  await epsClient.delete(`${BASE_PATH}/${id}`)
}

export const bulkDeleteOverrideRules = async (
  body: BulkDeleteOverrideRulesRequestDto
): Promise<void> => {
  await epsClient.delete(`${BASE_PATH}/bulk`, { data: body })
}

export const deleteOverrideRulesByFilter = async (
  params: DeleteOverrideRulesByFilterRequestDto
): Promise<DeleteOverrideRulesByFilterResponseDto> => {
  const { data } = await epsClient.delete(BASE_PATH, { params })
  return data as DeleteOverrideRulesByFilterResponseDto
}

export const bulkUpdateStatusByIds = async (
  body: BulkUpdateStatusByIdsRequestDto
): Promise<void> => {
  await epsClient.patch(`${BASE_PATH}/bulk/status`, body)
}

export const updateStatusByFilter = async (
  query: UpdateStatusByFilterQueryDto,
  body: UpdateStatusByFilterBodyDto
): Promise<UpdateStatusByFilterResponseDto> => {
  const { data } = await epsClient.patch<UpdateStatusByFilterResponseDto>(
    `${BASE_PATH}/status`,
    body,
    { params: query }
  )
  return data
}

export const upsertOverrideRuleField = async (
  body: UpsertFieldRequestDto
): Promise<PlanBenefitOverrideRuleResponseDto> => {
  const { data } = await epsClient.post<PlanBenefitOverrideRuleResponseDto>(
    `${BASE_PATH}/upsert-field`,
    body
  )
  return data
}
